(function () {
  const activateMedia = (modal, mediaId) => {
    modal.querySelectorAll('.mj-zoom__stage [data-media-id]').forEach((el) => {
      el.classList.toggle('active', el.getAttribute('data-media-id') === mediaId);
    });
    modal.querySelectorAll('.mj-zoom__thumb').forEach((el) => {
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === mediaId);
    });
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.mj-zoom__thumb');
    if (!thumb) return;

    const modal = thumb.closest('product-modal.mj-zoom');
    if (!modal) return;

    event.preventDefault();
    event.stopPropagation();
    activateMedia(modal, thumb.getAttribute('data-media-id'));
  });

  const bindOpenSync = (modal) => {
    const originalShow = modal.show.bind(modal);
    modal.show = (opener) => {
      originalShow(opener);
      const mediaId = opener && opener.getAttribute('data-media-id');
      if (mediaId) activateMedia(modal, mediaId);
    };
  };

  const init = () => {
    document.querySelectorAll('product-modal.mj-zoom').forEach(bindOpenSync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
